import { useEffect, useState, useRef } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import database from './config/FirbaseConfig';
import "firebase/compat/auth";
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';

import mrqalogo from './assets/mqra.png';

import Home from './pages/Home';
import Landing from './pages/Landing';
import BestMenu from './pages/BestMenu';
import PageNotFound from './pages/PageNotFound';
import ScreenSize from './pages/ScreenSize';
import CustomPage from './pages/CustomPage';
import Cart from "./components/Cart";
import LoginAndInfo from "./components/LoginAndInfo";
import RSVP from './pages/RSVP';
import ABTest from './custom/ABTest';
import { ColorGame } from './components/games/ColorGame';
import { PuzzleGame } from './components/games/PuzzleGame';
import { ShapeGame } from './components/games/ShapeGame';
import { SoundGame } from './components/games/SoundGame';
import { TimeGame } from './components/games/TimeGame';
import { TopNav } from './components/gamesshared/IntroScreen';
import { armAudioGestures } from './components/gameslib/audio';
import { GameSettingsProvider, useGameSettings } from './components/gameslib/gameSettings';


function App() {
  const [restaurantID, setRestaurantID] = useState(null);
  const [data, setData] = useState(JSON.parse(localStorage.getItem(`${restaurantID}_SavedData`)) || null);
  const [menuObj, setMenuObj] = useState([]);
  const [Dietary, setDietary] = useState(JSON.parse(localStorage.getItem(`${restaurantID}_DietaryPref`)) || {});
  const [DietaryFilters, setDietaryFilters] = useState(null);
  const [Ordering, setOrdering] = useState(true);
  const [Messages, setMessages] = useState(null);
  const [NavigationSuggestions, setNavigationSuggestions] = useState(null);
  const [cart, setCart] = useState(JSON.parse(localStorage.getItem(`${restaurantID}_Cart`)) || []);
  const [showButton, setShowButton] = useState(false);
  const scrollToTopRef = useRef(null);
  const [buttonZIndex, setButtonZIndex] = useState(0);
  const [isCartOpen, setIsCartOpen] = useState(false);

  useEffect(() => {
    const layoutEnabled = data?.HomePageLayout?.[2]?.Status === "Enable";
    const menuArray = Array.isArray(data?.Menu) ? data.Menu : [];

    // store preference once
    localStorage.removeItem(`${restaurantID}_DietaryPref`);
    localStorage.setItem(`${restaurantID}_DietaryPref`, JSON.stringify(Dietary));

    const filterMenuByDietary = (menuArray) => {
      if (!menuArray?.length) return [];

      const activeFilters = Object.entries(Dietary).filter(
        ([, subOpt]) => subOpt
      );

      if (activeFilters.length === 0) return menuArray;

      return menuArray.filter((item) => {
        const labels = Array.isArray(item?.Labels)
          ? item.Labels
          : Object.keys(item?.Labels || {}).filter((k) => item.Labels[k]);

        const matches = (value) =>
          labels.includes(value) ||
          value === item?.Dietary ||
          (value === "Frequently Ordered" && item?.IsBestSeller) ||
          (value === "New" && item?.IsNew) ||
          (value === "Popular" && item?.IsPopular) ||
          (value === "Recommended" && item?.IsRecommended) ||
          item?.SearchKeys?.includes(value);

        return activeFilters.every(([filterName, subOpt]) => {
          const def = DietaryFilters?.[filterName];
          if (!def) return true;

          const mustInclude = def.includeMap?.[subOpt] || [];
          const mustExclude = def.excludeMap?.[subOpt] || [];

          if (mustInclude.length && !mustInclude.some(matches)) return false;
          if (mustExclude.some(matches)) return false;

          return true;
        });
      });
    };

    if (layoutEnabled && menuArray.length) {
      setMenuObj(filterMenuByDietary(menuArray));
    } else {
      setMenuObj(menuArray);
    }
  }, [Dietary, data, restaurantID, DietaryFilters]);

  useEffect(() => {
    const checkAndGetMenu = async () => {
      try {
        // const hostname = window.location.hostname;
        // console.log('Hostname:', hostname);

        // const restaurantIDSnapshot = await database.ref(`hostnames/${hostname.replace('.', '_').replace('.', '_').replace('.', '_').replace('.', '_').replace('.', '_')}`).once('value');
        // const restaurantID = restaurantIDSnapshot.val();
        // console.log('Fetched restaurantID:', restaurantID);
        const restaurantID = 1775895687039;
        setRestaurantID(restaurantID);

        const now = Date.now();
        console.log('Current time:', now);

        const TWENTY_FOUR_HOURS = 12 * 60 * 60 * 1000;

        const LastModifiedOnSnap = await database.ref(`restaurants/${restaurantID}/LastModifiedOn/P`).once('value');
        const LastModifiedOnData = LastModifiedOnSnap.val();

        const lastScannedRaw = localStorage.getItem(`${restaurantID}_MenuFetchedOn`);
        const lastScanned = lastScannedRaw ? parseInt(lastScannedRaw, 10) : null;
        const shouldFetchMenu =
          !lastScanned || // No scan yet
          (now - lastScanned > TWENTY_FOUR_HOURS) || // Last scan over 24h ago
          ((LastModifiedOnData && lastScanned) && (LastModifiedOnData > lastScanned)) || // Menu was updated since last scan
          localStorage.getItem(`${restaurantID}_SavedData`) === null; // No saved menu

        if (shouldFetchMenu) {
          localStorage.setItem(`${restaurantID}_MenuFetchedOn`, now.toString());
          console.log('Fetching updated menu...');
          const MenuSnap = await database.ref(`restaurants/${restaurantID}`).once('value');
          const menuData = MenuSnap.val();

          if (menuData) {
            setData(menuData);
            // console.log(menuData)
            setOrdering(menuData?.['MenuOrdering'] || null);
            setDietaryFilters(menuData?.['PreferencesFilters'])
            setMessages(menuData?.['Messages']);
            setNavigationSuggestions(menuData?.['NavigationSuggestions']);
            localStorage.setItem(`${restaurantID}_SavedData`, JSON.stringify(menuData));
          } else {
            const menuData = JSON.parse(localStorage.getItem(`${restaurantID}_SavedData`));
            setData(menuData);
            // console.log(menuData)
            setOrdering(menuData?.['MenuOrdering'] || null);
            setDietaryFilters(menuData?.['PreferencesFilters'])
            setMessages(menuData?.['Messages']);
            setNavigationSuggestions(menuData?.['NavigationSuggestions']);
            console.log('No menu data found');
          }
        } else {
          const menuData = JSON.parse(localStorage.getItem(`${restaurantID}_SavedData`));
          setData(menuData);
          // console.log(menuData)
          setOrdering(menuData?.['MenuOrdering'] || null);
          setDietaryFilters(menuData?.['PreferencesFilters'])
          setMessages(menuData?.['Messages']);
          setNavigationSuggestions(menuData?.['NavigationSuggestions']);
          console.log('Menu is up to date');
        }
        setCart(JSON.parse(localStorage.getItem(`${restaurantID}_Cart`)) || []);
      } catch (error) {
        console.error(error.message);
      }
    }

    checkAndGetMenu();
  }, []);

  const changeFavicon = (newFaviconUrl) => {
    const favicon = document.getElementById('favicon');
    if (favicon && newFaviconUrl && newFaviconUrl.includes('https://')) {
      favicon.href = newFaviconUrl;
    }
  };

  useEffect(() => {
    document.title =
      data?.RestaurantDetails?.["Restaurant Name"] || "Menu QR Ate";

    const metaDesc =
      document.querySelector('meta[name="description"]') ||
      document.createElement("meta");
    metaDesc.name = "description";
    metaDesc.content =
      (data?.RestaurantDetails?.['Description'] ? data?.RestaurantDetails?.['Description'] : "Best Digital Menu.") + (data?.RestaurantDetails?.['Tagline'] ? " " + data?.RestaurantDetails?.['Tagline'] : "");

    document.head.insertBefore(metaDesc, document.head.firstChild);

    const metaKeywords =
      document.querySelector('meta[name="keywords"]') ||
      document.createElement("meta");
    metaKeywords.name = "keywords";
    metaKeywords.content =
      data?.RestaurantDetails?.["Key Words"] || "MQR8, Menu QR Ate, Digital Menu, Online Menu, QR Menu, Menu, Restaurant";
    document.head.insertBefore(metaKeywords, document.head.firstChild);

    changeFavicon(data?.RestaurantDetails?.['Logo']);

    const headerScripts = data?.['Marketing']?.['Header']
    if (headerScripts) {
      for (let i = headerScripts.length - 1; i >= 0; i--) {
        const tagData = headerScripts[i];
        const tagName = tagData[1];
        const tagContent = tagData[2];
        if (tagName && tagContent && tagName.trim() !== '' && tagContent.trim() !== '') {
          const fullHtmlString = `\n${tagContent}\n`;
          const template = document.createElement('template');
          template.innerHTML = fullHtmlString;
          document.head.insertBefore(template.content, document.head.firstChild);
        }
      }
    }

    const bodyScripts = data?.['Marketing']?.['Body']
    if (bodyScripts) {
      for (let i = bodyScripts.length - 1; i >= 0; i--) {
        const tagData = bodyScripts[i];
        const tagName = tagData[1];
        const tagContent = tagData[2];
        if (tagName && tagContent && tagName.trim() !== '' && tagContent.trim() !== '') {
          const fullHtmlString = `\n${tagContent}\n`;
          const template = document.createElement('template');
          template.innerHTML = fullHtmlString;
          document.body.insertBefore(template.content, document.body.firstChild);
        }
      }
    }

  }, [data]);

  useEffect(() => {
    const handleScroll = () => {
      const y = window.scrollY;

      setShowButton(y > 100);

      setButtonZIndex(y >= 55 ? 10 : 0);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrollToTopRef]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Smooth scrolling animation
    });
  };

  const GlobalNavComponents = ({
    cart,
    setCart
  }) => {
    const location = useLocation();
    const excludedRoutes = [
      "/dashboard",
      "/Games",
      "/Game",
      "/TicTacToe",
      "/FourPicsOneWord",
      "/Playlist",
      "/Coupons",
      "/ThankYouOrderPlaced",
      "/ServerOrderPage",
    ];

    const shouldShow = !excludedRoutes.some((route) =>
      location.pathname.toLowerCase().startsWith(route.toLowerCase())
    );

    if (!shouldShow) return null;

    return (
      <>
        <LoginAndInfo logo={data?.RestaurantDetails?.['Logo']} />
        <Cart cart={cart} setCart={setCart} isOpen={isCartOpen} setIsOpen={setIsCartOpen} />
      </>
    );
  };

  const { rounds, modeLabel } = useGameSettings()

  useEffect(() => armAudioGestures(), [])

  return (
    <>
      <div className="App">
        <BrowserRouter>
          {/* <GlobalNavComponents
            cart={cart}
            setCart={setCart}
            showButton={showButton}
            scrollToTopRef={scrollToTopRef}
            scrollToTop={scrollToTop}
            buttonZIndex={buttonZIndex}
          /> */}
          <Routes>
            {/* 2. Desktop Blocker (Screen Size check) */}
            {window.innerWidth > 777 ? (
              <Route path='*' element={<ScreenSize />} />
            ) : (
              /* 3. Mobile Routes */
              <>
                <Route path="/" element={<Home restaurantID={restaurantID} Layout={data?.['HomePageLayout']} Labels={data?.['Labels']} menuObj={menuObj} DietaryFilters={DietaryFilters} Dietary={Dietary} setDietary={setDietary} />} />
                <Route path="/Welcome" element={<Landing restaurantID={restaurantID} Layout={data?.['HomePageLayout']} Labels={data?.['Labels']} menuObj={menuObj} DietaryFilters={DietaryFilters} Dietary={Dietary} setDietary={setDietary} LandingPage={data?.['LandingPage']} cart={cart} setCart={setCart} RestaurantDetails={data?.['RestaurantDetails']} AddOns={data?.['Add-Ons']} Ordering={Ordering} Messages={Messages} NavigationSuggestions={NavigationSuggestions} />} />
                <Route path="Menu/">
                  <Route index element={<PageNotFound restaurantID={restaurantID} />} />
                  <Route path="CustomPage/:pageName" element={<CustomPage restaurantID={restaurantID} pages={data?.["CustomPages"]} />} />
                  <Route path=":filtertype/:filtervalue" element={<BestMenu restaurantID={restaurantID} RestaurantDetails={data?.['RestaurantDetails']} menuObj={menuObj} LabelsData={data?.['Labels']} DietaryFilters={DietaryFilters} Dietary={Dietary} setDietary={setDietary} AddOns={data?.['Add-Ons']} Ordering={Ordering} Messages={Messages} NavigationSuggestions={NavigationSuggestions} cart={cart} setCart={setCart} />} />
                  <Route path="*" element={<PageNotFound restaurantID={restaurantID} />} />
                </Route>
                {/* <Route path="/Games" element={<TopNav restaurantID={restaurantID} RestaurantDetails={data?.['RestaurantDetails']} />} /> */}
                <Route path="/Game/color" element={
                  <GameSettingsProvider><div className="app-shell">
                    <TopNav modeLabel={modeLabel} rounds={rounds} />
                    <main>
                      <ColorGame restaurantID={restaurantID} />
                    </main>
                  </div>
                  </GameSettingsProvider>} />
                <Route path="/Game/puzzle" element={
                  <GameSettingsProvider><div className="app-shell">
                    <TopNav modeLabel={modeLabel} rounds={rounds} />
                    <main>
                      <PuzzleGame restaurantID={restaurantID} />
                    </main>
                  </div>
                  </GameSettingsProvider>} />
                <Route path="/Game/shape" element={
                  <GameSettingsProvider><div className="app-shell">
                    <TopNav modeLabel={modeLabel} rounds={rounds} />
                    <main>
                      <ShapeGame restaurantID={restaurantID} />
                    </main>
                  </div>
                  </GameSettingsProvider>} />
                <Route path="/Game/sound" element={
                  <GameSettingsProvider><div className="app-shell">
                    <TopNav modeLabel={modeLabel} rounds={rounds} />
                    <main>
                      <SoundGame restaurantID={restaurantID} />
                    </main>
                  </div>
                  </GameSettingsProvider>} />
                <Route path="/Game/time" element={
                  <GameSettingsProvider><div className="app-shell">
                    <TopNav modeLabel={modeLabel} rounds={rounds} />
                    <main>
                      <TimeGame restaurantID={restaurantID} />
                    </main>
                  </div>
                  </GameSettingsProvider>} />
                <Route path="/ABTest" element={<ABTest />} />
                <Route path="/ABTest/:whichAB" element={<ABTest />} />
                <Route path="/RSVP/:invite/Samudaya9/RSVPform" element={<RSVP />} />
                <Route path="*" element={<PageNotFound restaurantID={restaurantID} />} />
              </>
            )}
          </Routes>
        </BrowserRouter>
      </div>
      <div className='FooterContainer'>
        <div className='SocialMediaLinksContainer'>
          &nbsp;
          <em>{data?.['RestaurantDetails']?.['Restaurant Name']}</em>
          &nbsp;
          {data?.['RestaurantDetails']?.['Social Media']?.['Google Maps'] &&
            <>
              <a href={data?.['RestaurantDetails']?.['Social Media']?.['Google Maps']} target="_blank" rel="noopener noreferrer"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" color='#555' fill="currentColor" className="bi bi-geo-alt-fill" viewBox="0 0 16 16">
                <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6" />
              </svg></a>
              &nbsp;
            </>
          }
          {data?.['RestaurantDetails']?.['Social Media']?.['Instagram'] &&
            <>
              <a href={data?.['RestaurantDetails']?.['Social Media']?.['Instagram']} target="_blank" rel="noopener noreferrer"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" color='#555' fill="currentColor" className="bi bi-instagram" viewBox="0 0 16 16">
                <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334" />
              </svg></a>
              &nbsp;</>
          }
          {data?.['RestaurantDetails']?.['Social Media']?.['Meta'] &&
            <>
              <a href={data?.['RestaurantDetails']?.['Social Media']?.['Meta']} target="_blank" rel="noopener noreferrer"><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" color='#555' fill="currentColor" className="bi bi-meta" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M8.217 5.243C9.145 3.988 10.171 3 11.483 3 13.96 3 16 6.153 16.001 9.907c0 2.29-.986 3.725-2.757 3.725-1.543 0-2.395-.866-3.924-3.424l-.667-1.123-.118-.197a55 55 0 0 0-.53-.877l-1.178 2.08c-1.673 2.925-2.615 3.541-3.923 3.541C1.086 13.632 0 12.217 0 9.973 0 6.388 1.995 3 4.598 3q.477-.001.924.122c.31.086.611.22.913.407.577.359 1.154.915 1.782 1.714m1.516 2.224q-.378-.615-.727-1.133L9 6.326c.845-1.305 1.543-1.954 2.372-1.954 1.723 0 3.102 2.537 3.102 5.653 0 1.188-.39 1.877-1.195 1.877-.773 0-1.142-.51-2.61-2.87zM4.846 4.756c.725.1 1.385.634 2.34 2.001A212 212 0 0 0 5.551 9.3c-1.357 2.126-1.826 2.603-2.581 2.603-.777 0-1.24-.682-1.24-1.9 0-2.602 1.298-5.264 2.846-5.264q.137 0 .27.018" />
              </svg></a>
              &nbsp;
            </>
          }
          {data?.['RestaurantDetails']?.['Social Media']?.['LinkedIn'] &&
            <>
              <a href={data?.['RestaurantDetails']?.['Social Media']?.['LinkedIn']} target="_blank" rel="noopener noreferrer"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" color='#555' fill="currentColor" className="bi bi-linkedin" viewBox="0 0 16 16">
                <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z" />
              </svg></a>
              &nbsp;
            </>
          }
        </div>
        <a className="mqralogo" href="https://ettarracoffee.com/" target="_blank" rel="noopener noreferrer">- Powered by&nbsp;&nbsp;
          <img src='https://firebasestorage.googleapis.com/v0/b/samudaya-ettarra.firebasestorage.app/o/favicon.ico?alt=media&token=50d4b5c3-04cc-4a5f-a321-9ccc65ef1251' alt="Menu QR Ate" />
        </a>
      </div>
      <>
        {showButton && (
          <button
            ref={scrollToTopRef}
            onClick={() => scrollToTop()}
            style={{
              position: 'fixed',
              top: '150px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: "125px",
              height: "30px",
              padding: '0px 10px',
              backgroundColor: '#FFFFFFDD',
              backdropFilter: 'blur(5px)',
              color: '#001E3A',
              border: 'none',
              borderRadius: '25px',
              cursor: 'pointer',
              zIndex: buttonZIndex,
              boxShadow: "0px 0px 25px #001E3A50",
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              alignItems: "center",
              fontSize: '12px',
              lineHeight: '12px',
              fontWeight: '600',
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="#001E3A"><path d="M440-160v-487L216-423l-56-57 320-320 320 320-56 57-224-224v487h-80Z" /></svg>&nbsp;Back to Top
          </button>
        )}
      </>
    </>
  );
}

export default App;